import AppDataTable from "./AppDataTable.jsx";

export default AppDataTable;
